<template lang="pug">
  v-container#header(fluid)
    v-layout(row wrap)
      v-flex(xs12)
        v-card.pb-3.pt-1(flat)
          v-layout(row wrap)
            v-flex(d-flex xs5 md3 lg2 align-center)
              router-link.home(to="/")
                img.logo(src="/static/logo.png")
            v-flex(d-flex xs7 md3)
              router-link.home(to="/")
                v-card-title.header-title.ml- Casos
            v-flex(d-flex align-center).text-xs-right.justify-end
              v-btn.mx-2.header-dark-btn.bold(color="black" @click="downloadData") Descargar datos
              v-btn.mx-2.header-btn.bold(outline color="red darken-3" to="/users" v-if="currentUser && currentUser.createUser") Administrar accesos
              p.ml-2.mr-4.salir.bolder(@click="logout") Salir
    v-divider
</template>

<script>
export default {
  name: "Header",
  props: {},
  computed: {
    currentUser() {
      return this.$store.state.user.permission;
    },
  },
  methods: {
    logout() {
      this.$store.commit("resetUser");
      localStorage.clear();
      this.$router.replace("/login");
    },
    downloadData() {
      window.open('https://s3.amazonaws.com/media.crimenesdeodio.letraese.org.mx/Reportes.csv', '_blank');
      // window.open('https://s3.amazonaws.com/images.letraese.datacivica.org/Reportes.csv', '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
#header {
  .logo {
    max-width: 195px;
  }
  .home {
    text-decoration: none;
  }
  .salir {
    text-decoration: underline;
    max-width: fit-content;
    &:hover {
      cursor: pointer;
    }
  }

  .header-btn {
    max-width: fit-content;
  }

  .header-dark-btn {
    max-width: fit-content;
    color: #fff;
  }
}
</style>
